import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import DriverService from "services/driver.service";
import SelectRedux from "components/molecules/ComboBoxRedux";
import PrivilegeService from "utils/privilege.util";

export default function SelectSearchDriver(props: any) {
	const { meta } = props;
	const driverOptions = useAppSelector((state) => state.driver.driverOptions);
	const permissions = useAppSelector((state) => state.auth?.user?.role_id?.permissions);

	useEffect(() => {
		if (PrivilegeService.checkPrivilege("driver:read", permissions)) {
			let data: any = {};
			if (meta?.form === 'DriverLocationTrackingFiltersForm' || meta?.form === 'AddGroupTrackingForm') {
				const partner_id = {
					development: "64fb1c9937a2a1b4fa9b908a",
					staging: "64fb1c9937a2a1b4fa9b908a",
					production: "63ea0b28c32eebbb57a7cc5e",
				};
				data.partner_id = partner_id[process.env.NODE_ENV as keyof typeof partner_id];
			}

			DriverService.getAllDrivers(data);
		}
	}, []);

	return <SelectRedux {...props} options={driverOptions} />;
}
